import React from "react";
import { TbMail, TbPencil, TbPhone } from "react-icons/tb";
import {
  Avatar,
  Button,
  Col,
  Dialog,
  FabButton,
  Flex,
  Gap,
  InputField,
  Row,
  SelectField,
  Typography,
} from "../../../ppui";
import { Icon } from "../../../ppui/icon";
import {
  CardViewBox,
  CardViewBoxBorder,
} from "../../style";
import useOwnershipDetailsService from "./user-ownership-info-service";

const OrgOwnershipInfo = () => {
  // State for each modal's visibility
  const { ownerShipDetails } = useOwnershipDetailsService();
  const [openOwnershipInfo, setOpenOwnershipInfo] = React.useState(false);

  // Details modal
  const handleOpenOwnershipInfoModal = () => setOpenOwnershipInfo(true);
  const handleCloseOwnershipInfoModal = () => setOpenOwnershipInfo(false);

  return (
    <>
      {/* View-Part */}
      <Flex justifyContent="space-between" gap={"10"}>
        <Typography variant="h5" mb={"0"}>
          Ownership Information
        </Typography>

        <Button
          color="primary"
          variant="outlined"
          onClick={handleOpenOwnershipInfoModal}
          size="sm"
        >
          Add New
        </Button>
      </Flex>
      <Gap height={30} />

      <Row rowGap mb={20}>
        {ownerShipDetails?.map((owner,) => (
          <>
            <Col sm={12} md={6} lg={6} xl={6} xxl={6}>
              <CardViewBox>
                <Row alignItem="center" mb={15}>
                  <Col sm={12} md={"auto"}>
                    <Avatar initials="TD" color={"primary"} />
                  </Col>

                  <Col sm={12} md={6} lg={6} xxl={4}>
                    <Typography variant="body1" strong mb={"0"} color="primary">
                      {owner?.name ?? "N/A"}
                    </Typography>
                    <Typography
                      variant="body2"
                      mb={"0"}
                      color="dark"
                      Colorvariant="light"
                    >
                      {owner?.designation ?? "N/A"}
                    </Typography>
                  </Col>

                  <Col sm={"auto"} ml={"auto"}>
                    <FabButton
                      icon={<TbPencil />}
                      shape="rounded"
                      size="sm"
                      variant="filled"
                    />
                  </Col>
                </Row>
                <CardViewBoxBorder />
                <Flex alignItem="center" gap={"5"}>
                  <Icon size={"sm"}>
                    <TbPhone />
                  </Icon>

                  <Typography variant="body2" mb={"0"}>
                    {owner?.phone ?? "N/A"}
                  </Typography>
                </Flex>

                <Flex alignItem="center" gap={"5"}>
                  <Icon size={"sm"}>
                    <TbMail />
                  </Icon>

                  <Typography variant="body2" mb={"0"}>
                    {owner?.email ?? "N/A"}
                  </Typography>
                </Flex>

                <CardViewBoxBorder />
                <Row mb={10}>
                  {owner?.pan && (
                    <Col sm={"auto"}>
                      {" "}
                      <Typography variant="body2" mb={"0"}>
                        PAN: {owner?.pan ?? "N/A"}
                      </Typography>
                    </Col>
                  )}
                  {owner?.identity_no && (
                    <Col sm={"auto"}>
                      {" "}
                      <Typography variant="body2" mb={"0"}>
                        ID No: {owner?.identity_no ?? "N/A"}
                      </Typography>
                    </Col>
                  )}
                </Row>
              </CardViewBox>
            </Col>
          </>
        ))}
      </Row>
      <Gap height={50} />

      {/* Ownership-Modal */}
      <Dialog
        title="Ownership Information"
        closeButton={true}
        fullWidth
        maxWidth="sm"
        buttonName={"Update"}
        open={openOwnershipInfo}
        onClose={handleCloseOwnershipInfoModal}
        onSubmit={() => alert("Submitted")}
        separator
      >
        <Row rowGap>
          <Col sm={6}>
            <InputField
              fullWidth
              label="Owner Name"
              placeholder="Type Here..."
              type="text"
              required
            />
          </Col>

          <Col sm={6}>
            <InputField
              fullWidth
              label="Phone"
              placeholder="Type Here..."
              type="tel"
              required
            />
          </Col>

          <Col sm={6}>
            <InputField
              fullWidth
              label="Email"
              placeholder="Type Here..."
              type="email"
              required
            />
          </Col>

          <Col sm={6}>
            <SelectField
              fullWidth
              label="Designation"
              name="industry_type"
              options={[
                { id: "option1", name: "Yes" },
                { id: "option2", name: "No" },
              ]}
              placeholder="Select Here..."
            />
          </Col>

          <Col sm={6}>
            <InputField
              fullWidth
              label="Identity No"
              placeholder="Type Here..."
              type="tel"
            />
          </Col>

          <Col sm={6}>
            <InputField
              fullWidth
              label="PAN"
              placeholder="Type Here..."
              type="text"
            />
          </Col>
        </Row>
      </Dialog>
      {/* Ownership-Modal */}
    </>
  );
};

export default OrgOwnershipInfo;
